<template>
  <z-action-picker
    v-model="show"
    v-zpm="{
      sectionid: 109,
      areaexposure: 109,
      legoareabackup: {
        sortName: 'PK 去对比'
      }
    }"
    :show-btn="isShowButton"
    btn-text="PK 去对比"
    height="80vh"
    title="参数详情"
    class="product-detail-popup"
    @confirm="pkJump"
  >
    <div class="params-content">
      <div v-if="filterParamBars && filterParamBars.length" class="params-content-model">
        <div v-for="item in filterParamBars" :key="item.title" class="content-list">
          <div class="model-title">{{ item.title }}</div>
          <div class="list-content">
            <div v-for="group in item.paramInfo" :key="group.paramName" class="item-content">
              <div class="item-label">{{ group.paramName }}</div>
              <div
                class="item-value"
                @click="group.qcWiki && $refs.refParamsPopup.togglePopup(group)"
              >
                <span>{{ group.paramValue }}</span>
                <z-icon
                  v-if="group.qcWiki"
                  class-prefix="zziconfont"
                  name="arrow-right"
                  size="9px"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="productDescribeInfo && productDescribeInfo.length" class="params-content-model">
        <div class="model-title" v-if="dataInfo.infoType == 1000">参数规格</div>
        <div v-for="(group, index) in productDescribeInfo" :key="index" class="content-list">
          <div class="list-title" v-if="dataInfo.infoType == 1000">
            {{ group.length ? group[0].groupName : '' }}
          </div>
          <div class="list-content-params">
            <div v-for="(item, subIndex) in group" :key="subIndex" class="item-content">
              <div class="item-label">{{ item.paramName }}</div>
              <div class="item-value">
                <span v-for="(list, i) in item.paramValueDTOList" :key="list.valueText"
                  >{{ list.valueText }}
                  <span v-show="i < item.paramValueDTOList.length - 1">; </span>
                </span>
                <img
                  v-if="dataInfo.infoType != 1000 && item.showTipBtn"
                  @click="specificationsClick(item)"
                  class="specifications"
                  :src="
                    $setPicSize(
                      'https://pic6.zhuanstatic.com/zhuanzh/449b3389-0a2b-410c-8b74-563750813b5c.png',
                      30,
                      30
                    )
                  "
                />
                <div class="param-tip" v-if="showValueTip(item)">
                  <div class="sizedesc-wrap" @click="handleOpen">
                    <span class="size-desc">{{ isOpen ? '收起说明' : '尺寸说明' }}</span>
                    <i class="icon" :class="isOpen ? 'close' : 'open'"></i>
                  </div>
                </div>
                <div v-if="showValueDesc(item)" class="desc">
                  显示尺寸均为手工测量，包袋、服装服饰类测量误差在±1-3CM左右，鞋靴类测量误差在±1-3CM左右，首饰类测量误差在±1MM左右，腕表表盘测量误差在±2MM左右，表带测量误差在±2CM左右，属正常范围。
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section v-show="showFeedback" class="feed-back">
        <z-platform-bch-entry
          type="bottom"
          position="right"
          questionnaireId="1647870306162840065"
          getContainer="body"
          :canBack="1"
          :openType="3"
          :outAppOpenType="2"
          :multiple="true"
          :extend="{
            pageName: '参数规格',
            ...feedbackData
          }"
          @watchShow="feedbackCallback"
        />
      </section>
    </div>
    <paramsPopup ref="refParamsPopup" />
  </z-action-picker>
</template>

<script lang="ts">
import Vue from 'vue'
import { computed, defineComponent, ref } from '@vue/composition-api'
import paramsPopup from './params-bar-popup.vue'
import {
  Popup,
  Tab,
  Tabs,
  Table,
  PlatformBchEntry,
  Icon,
  Button,
  ActionPicker
} from '@zz-common/zz-ui'
import { skipToUrl } from '@utils/native'
Vue.use(Popup)
  .use(Tab)
  .use(Tabs)
  .use(Table)
  .use(PlatformBchEntry)
  .use(Icon)
  .use(Button)
  .use(ActionPicker)

export default defineComponent({
  components: {
    paramsPopup
  },
  props: {
    dataInfo: {
      type: Object,
      default: () => ({})
    },
    feedbackData: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props, ctx) {
    const show = ref(false) // 参数规格弹窗状态
    const isOpen = ref(false)

    /**
     * $ 参数规格
     */
    const productDescribeInfo = computed(() => {
      const { dataInfo } = props
      // TIPS: 暂时注释  待删除
      if (dataInfo?.infoType != 1000) {
        return dataInfo?.luxuryDescribeInfo || []
      }
      return dataInfo?.productDescribeInfo || []
    })

    /**
     * $ 机况信息
     */
    const filterParamBars = computed(() => {
      return props.dataInfo?.report?.reportParam?.paramDetail || []
    })

    /**
     * $ 是否显示去pk按钮
     */
    const isShowButton = computed(() => {
      return props.dataInfo?.comparisonInfoVo?.showButton == 1
    })

    /**
     * $ 二奢融合
     */
    // TODO: 二奢融合
    const togglePopup = () => {
      show.value = !show.value
    }

    /**
     * $ 是否显示反馈
     */
    const showFeedback = ref(true)
    const feedbackCallback = (val) => {
      showFeedback.value = !!val
    }

    /**
     * $ 去pk跳转
     */
    const pkJump = () => {
      if (isShowButton.value && props.dataInfo?.comparisonInfoVo?.jumpUrl) {
        skipToUrl({
          targetUrl: props.dataInfo.comparisonInfoVo.jumpUrl
        })
      }
    }

    /**
     * $ 二奢参数规格点击事件
     */
    // TODO: 二奢融合
    const specificationsClick = (item) => {
      ctx.emit('openPopupWarchPedia', item.paramId)
    }

    const handleOpen = () => {
      isOpen.value = !isOpen.value
    }

    const showValueTip = (item) => {
      return item?.paramId === 7043
    }

    const showValueDesc = (item) => {
      // isOpen 为true 且 只有尺寸参数才展示
      if (isOpen.value && item?.paramId === 7043) {
        return true
      }
      return false
    }

    return {
      show,
      filterParamBars,
      productDescribeInfo,
      togglePopup,
      showFeedback,
      feedbackCallback,
      isShowButton,
      pkJump,
      specificationsClick,
      handleOpen,
      showValueTip,
      showValueDesc,
      isOpen
    }
  }
})
</script>

<style lang="scss" scoped>
.product-detail-popup {
  // padding: 32px 36px 0;
}

.params-content {
  padding: 0 36px;
  &::-webkit-scrollbar {
    display: none;
  }

  .content-title {
    margin-bottom: 33px;
    color: #111;
    font-weight: 500;
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    line-height: 32px;
  }

  .model-title {
    margin-bottom: 33px;
    color: #111;
    font-weight: 500;
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    line-height: 32px;
  }
  .content-list {
    margin-bottom: 68px;
    .list-title {
      margin: 48px 0 24px;
      color: #111;
      font-weight: 400;
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      line-height: 32px;
    }

    .list-content {
      display: flex;
      flex-wrap: wrap;
      overflow: hidden;
      background: #f8f9fd;
      border-radius: 12px;
      .item-content {
        display: flex;
        align-items: center;
        width: calc(50% - 4px);
        height: 88px;
        margin-bottom: 4px;
        font-size: 22px;
        line-height: 24px;
        border-right: #fff 2px solid;
        border-bottom: #fff 2px solid;
        .item-label {
          width: 90px;
          min-width: 90px;
          margin: 0 22px 0 0;
          padding: 0 20px;
          color: #999;
          font-weight: 300;
          font-family: PingFangSC-Light, PingFang SC;
          // white-space: nowrap;
        }

        .item-value {
          display: flex;
          align-items: center;
          color: #111;
          font-weight: 400;
          font-family: PingFangSC-Regular, PingFang SC;
        }
      }
      .item-content:nth-child(2n) {
        border-right: none;
        border-left: #fff 2px solid;
      }
      .item-content:nth-last-child(-n + 2) {
        margin-bottom: 0;
      }
    }

    // 参数规格
    .list-content-params {
      overflow: hidden;
      border-radius: 12px;
      // display:;
      .item-content {
        display: flex;
        .item-label {
          display: flex;
          align-items: center;
          width: 200px;
          margin: 0 0 4px;
          padding: 27px 10px 27px 20px;
          color: #999;
          font-weight: 300;
          font-size: 22px;
          font-family: PingFangSC-Light, PingFang SC;
          background: #f8f9fd;
          border-right: 4px solid #fff;
        }
        .item-value {
          width: calc(100% - 206px);
          margin-bottom: 4px;
          padding: 27px 10px 27px 20px;
          color: #111;
          font-weight: 400;
          font-weight: 400;
          font-size: 22px;
          font-family: PingFangSC-Regular, PingFang SC;
          background: #f8f9fd;
          .specifications {
            position: relative;
            top: 3px;
            width: 20px;
            height: 20px;
            margin-left: 4px;
            color: #999999;
            font-size: 20px;
            vertical-align: baseline;
          }
          .param-tip {
            display: inline-block;

            .sizedesc-wrap {
              display: flex;
              align-items: center;
              justify-content: center;

              .size-desc {
                height: 32px;
                color: #666666;
                font-weight: 300;
                font-size: 20px;
                font-family: PingFangSC-Light, PingFang SC;
                line-height: 32px;
              }

              .icon {
                width: 20px;
                height: 20px;
                background-repeat: no-repeat;
                background-size: 100% 100%;
              }

              .open {
                background-image: url('https://pic2.zhuanstatic.com/zhuanzh/32e03d71-36d3-4a6c-84f7-b8d606e55c96.png');
              }

              .close {
                background-image: url('https://pic1.zhuanstatic.com/zhuanzh/a74c91ca-7988-482b-9400-0f617a875936.png');
              }
            }
          }
          .desc {
            height: 202px;
            color: #999;
            font-weight: 300;
            font-size: 24px;
            font-family: PingFangSC-Light, PingFang SC;
            line-height: 32px;
          }
        }
      }
    }
  }
}

/deep/ .params-tab *::before,
.params-tab *::after {
  border-color: #e9e9e9;
}

/deep/ .z-swipe__track {
  display: flex;
  flex-wrap: nowrap;
}

/deep/ .z-swipe-item {
  margin-left: 1px;
}

/deep/ .z-tabs__line {
  width: 28px;
  height: 4px;
  background: #ff483c;
  border-radius: 2px;
}

.header {
  margin-top: 34px;
  margin-bottom: 60px;
  text-align: center;

  .title {
    position: relative;
    top: -8px;
    display: inline-block;
    color: #111;
    font-weight: 500;
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    line-height: 32px;
  }

  .close {
    position: fixed;
    top: 36px;
    right: 32px;
    width: 24px;
    height: 24px;
  }
}

.feed-back {
  padding: 65px 0 80px;
}

.faulty-bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 999;
  box-sizing: border-box;
  width: 100vw;
  height: 140px;
  padding: 20px 24px;
  background-color: #fff;
  .z-button {
    position: absolute;
    bottom: 40px;
    left: 24px;
    z-index: 9999;
    width: calc(100% - 48px);
    padding: 0;
    color: #fff;
    font-weight: 500;
    font-size: 28px;
    font-family: PingFangSC-Medium, PingFang SC;
    line-height: 28px;
  }
}
// }
</style>
